import "../styles/footer.css";

import { FaGithub, FaInstagram, FaTwitter } from "react-icons/fa";

export default function Footer() {
  // Function to navigate between page
  function goTo(elementId) {
    var element = document.getElementById(elementId);
    element.scrollIntoView({
      block: "start",
      behavior: "smooth",
    });
    return false;
  }

  return (
    <footer className="footer">
      <div className="footer__container container">
        <h1 className="footer__title">Vaibhav</h1>

        <ul className="footer__list">
          <li>
            <button onClick={() => goTo("about")} className="footer__link">
              About
            </button>
          </li>

          <li>
            <button onClick={() => goTo("projects")} className="footer__link">
              Projects
            </button>
          </li>

          <li>
            <button
              onClick={() => goTo("testimonial")}
              className="footer__link"
            >
              Testimonial
            </button>
          </li>
        </ul>

        <ul className="footer__social">
          <a
            href="https://instagram.com/that_back.bencher"
            target="_blank"
            rel="noreferrer"
            className="footer__social_link"
          >
            <FaInstagram />
          </a>

          <a
            href="https://github.com/vaibhavaswal"
            target="_blank"
            rel="noreferrer"
            className="footer__social_link"
          >
            <FaGithub />
          </a>

          <a
            href="https://twitter.com/vaibhav_says"
            target="_blank"
            rel="noreferrer"
            className="footer__social_link"
          >
            <FaTwitter />
          </a>
        </ul>
        <h2 className="footer__love">
          Made with&nbsp;
          <span className="red">♥</span>&nbsp;by&nbsp;
          <a
            href="https://instagram.com/that_back.bencher"
            target="_blank"
            rel="noreferrer"
            className="footer__credit"
          >
            Vaibhav Aswal
          </a>
        </h2>

        <span className="footer__copy">
          &#169; Vaibhav Aswal. All rights reserves
        </span>
      </div>
    </footer>
  );
}
